<template>
  <div class="privateChat">
    <commonTable
      ref="commonTable"
      url="/admin/callback_money/zone_callback"
      reqMethod="GET"
      :column="column"
      :extraParams="{
        ...extraParams,
        is_role: Number(!switchValue),
        is_money: Number(switchValue),
      }"
      :searchColumn="searchColumn"
      @reset="() => {
        extraParams = {
          game_id: null,
        }
        switchValue = false
        dateColumn = false
      }"
      limitKey="per_page"
      @onGetData="onGetData"
      @isLoading="(val) => listLoading = val"
      @onSearch="() => dateColumn = false"
    >
      <template slot="search-back">
        <el-form-item>
          <el-switch
            v-model="switchValue"
            inactive-text="活跃"
            active-text="付费">
          </el-switch>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="extraParams.game_id"
            clearable
            filterable
            placeholder="游戏列表">
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="search" slot-scope="scope">
        <el-button
          type="success"
          plain
          icon="el-icon-download"
          class="mb1"
          :loading="exportLoading"
          :disabled="listLoading"
          @click="exportZoneReport(scope)">导出</el-button>
      </template>
    </commonTable>
  </div>
</template>

<script>
import fetch from "@/assets/js/axios.js"
import commonTable from '@/component/commonTable.vue'
import { exportData } from '@/assets/js/exportData'

export default {
  name: 'payZoneReport',
  data () {
    return {
      switchValue: false,
      listLoading: false,
      exportLoading: false,
      extraParams: {
        game_id: null,
      },
      gamesList: [],
      dateColumn: false,
      column: [],
      fixedColumn: [
        {
          label: "日期",
          prop: "this_date",
          fixed: true,
          width: '110'
        },
        {
          label: "游戏",
          prop: "game.name",
          fixed: true,
          width: '100',
        },
        // {
        //   label: "区服",
        //   prop: "zone_name",
        //   fixed: true,
        //   width: '100',
        // },
      ]
    }
  },
  computed: {
    searchColumn () {
      return [
        {
          label: "日期",
          prop: "created_from+created_to",
          type: "datetime",
          setDefaultWeek:true
        },
      ]
    }
  },
  components: {
    commonTable
  },
  mounted () {
    this.getGameSelectList()
  },
  methods: {
    async exportZoneReport ({ totalRecords, searchValue }) {
      if (this.listLoading || this.exportLoading) return
      if (!totalRecords || !this.column.length) {
        this.$message.warning('暂无可导出的数据')
        return
      }

      this.exportLoading = true
      try {
        await exportData({
          url: '/admin/callback_money/zone_callback',
          name: '当日区服详情-' + (this.switchValue ? '付费' : '活跃'),
          column: this.column.map(item => ({ ...item })),
          limit: 'per_page',
          method: 'GET',
        }, {
          totalRecords,
          searchValue: {
            ...searchValue,
            ...this.extraParams,
            is_role: Number(!this.switchValue),
            is_money: Number(this.switchValue),
          },
        })
      } catch (error) {
        this.$message.error('导出失败，请稍后重试')
      } finally {
        this.exportLoading = false
      }
    },
    onGetData (data) {
      if (!this.dateColumn && data?.length) {
        let column = [
          {
            label: '累积' + (this.switchValue ? "付费" : "活跃"),
            prop: this.switchValue ? "money" : "login_num",
            fixed: true,
            width: '100',
          }
        ]
        const date0 = data[0]
        for (let key in date0) {
          if (key && !['game','game_id','this_date','login_num','zone_id','zone_name', 'money'].includes(key)) {
            column.push({
              prop: key,
              label: key,
              width: '110'
            })
          }
        }
        if (column?.length) {
          this.dateColumn = true
          this.column = this.fixedColumn.concat(column)
          this.$refs.commonTable.layout()
        }
      }
    },
    // 获取游戏选择列表数据
    getGameSelectList() {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        this.gamesList = res.data.data
      })
    },
  }
}
</script>

<style lang="less">
.privateChat .el-image-viewer__close {
  top: 100px;
  color: red;
}
</style>
